module.exports = __webpack_public_path__ + "img/strap length.1850faa3.png";